const removeWaterMark = {
  ExportVideoWithoutWaterMark: 'Exportar Video Sin HitPaw Marca de Agua',
  ExportWithoutLimits: 'Exportar Video Sin Límites',
  MaximumUpload500MB: 'Tamaño Máximo del Archivo Cargado: 500 MB',
  watermarkRemoveTitle: 'HitPaw Quitar Marca de Agua de Video Online',
  DiscountPrice: '0.99€',
  WeekTotalPrice: '4.49€',

  MonthWeekPrice: '1.75€',
  MonthTotalPrice: '6.99€',

  YearWeekPrice: '0.87€',
  YearTotalPrice: '41.88€',
  Day: 'Día',
  Monthly: 'Mensualmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  week: 'Semana',
};

export default removeWaterMark;
